import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { BookmarkCategory } from '../../models/bookmark-category';
import { withBookmarkCategorySelectors } from './bookmark-category.selectors';
import { BookmarkCategoryService } from '../../services/bookmark-category/bookmark-category.service';
import { inject } from '@angular/core';
import { ActiveUserStore } from '../user/active-user.state';
import { BookmarkStore } from '../bookmark/bookmark.state';
import { StoryStore } from '../story/story.state';
import { withLogging } from '../features/logger.feature';

export type BookmarkCategoryState = BaseState<BookmarkCategory>;

export const initialState: BookmarkCategoryState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'BookmarkCategory',
  entityLabel: 'Themenbereich',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const BookmarkCategoryStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<BookmarkCategory>(BookmarkCategoryService),
  withLogging(initialState.entityType),
  withMethods(store => ({
    isPrivate(categoryId: string) {
      return store.items()[categoryId]?.private || false;
    },
  })),
  withBookmarkCategorySelectors(),
  withHooks({
    onInit(store) {
      store.loadAllItemsByPromise();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
